import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Purchases/MaterialRequest/forms";
import headers from "../../../../Data/Forms/Purchases/MaterialRequest/headers";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import MRTable from "../../../../Data/Forms/Purchases/MaterialRequest/table";
import toast from "react-hot-toast";
import {
    create_material_request,
    get_material_request,
    update_material_request,
} from "../../../../Controllers/Purchases/MaterialRequests";

const MaterialRequestForm = () => {
    let { id } = useParams();
    let navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [values, setValues] = useState(forms);

    const focus = useRef([]);

    const [details, setDetails] = useState([
        {
            id: "",
            description: null,
            name: "",
            unit: "",
            unit_name: "",
            unit_details_options: null,
            conversion: 0,
            quantity_requested: "",
            options: [],
        },
    ]);

    const detailsvalidation = (tabledata) => {
        if (details?.length > 0) {
            let total = details?.length;
            let count = 0;
            let validated = [];

            details?.map((v, i) => {
                if (count == i) {
                    if (!v?.description) {
                        document.getElementById(`description${i}`).textContent =
                            "Description is required";
                        focus.current[`description${i}`].current.focus();
                    } else if (!v?.quantity_requested) {
                        document.getElementById(`quantity_requested${i}`).textContent =
                            "Quantity is required";
                        focus.current[`quantity_requested${i}`].current.focus();
                    } else {
                        document.getElementById(`description${i}`).textContent = "";
                        document.getElementById(`quantity_requested${i}`).textContent = "";
                        validated.push({ ...v, options: [] });
                        count++;
                    }
                }
            });

            if (count == total) {
                return { status: true, data: { ...tabledata, details: validated } };
            } else {
                return { status: false, data: null };
            }
        } else {
            toast?.error("Please add at least one item");
            return { status: false, data: null };
        }
    };

    const formdata = async (data) => {
        if (data?.status) {
            const validated = detailsvalidation(data?.data);

            if (validated?.status) {
                setButtonLoader(true);

                const result = id
                    ? await update_material_request({ ...validated?.data, id })
                    : await create_material_request(validated?.data);

                if (result?.status) {
                    navigate(-1);
                    toast?.success(result?.message);
                    setButtonLoader(false);
                } else {
                    setButtonLoader(false);
                    if (result?.status_code == 403) {
                        window.location.href = "/unauthorized";
                    } else {
                        toast?.error(result?.message);
                    }
                }
            }
        }
    };

    const handleData = (data) => {
        values[0].options[0].form.value = data?.date || "";
        values[0].options[1].form.value = data?.site?._id || null;
        values[0].options[1].form.options = data?.site?._id
            ? [{ value: data?.site?._id, label: data?.site?.name }]
            : null;
        values[0].options[2].form.value = data?.requested_by?._id || null;
        values[0].options[2].form.options = data?.requested_by?._id
            ? [{ value: data?.requested_by?._id, label: data?.requested_by?.name }]
            : null;
        values[0].options[3].form.value = data?.priority ?? 0;
        values[0].options[4].form.value = data?.notes || "";
        values[0].options[5].form.value = data?.request_status ?? 0;

        const detailData = data?.details?.map((value) => ({
            id: value?._id,
            description: value?.description?._id,
            name: value?.description?.product?.name || value?.name,
            unit: value?.unit,
            unit_name: value?.unit_name,
            unit_details_options: value?.unit_details_options || [],
            conversion: value?.conversion || 0,
            quantity_requested: value?.quantity_requested,
            options: [],
        }));

        setValues([...values]);
        setDetails(detailData);
        setLoader(false);
    };

    const fetchData = async () => {
        if (id) {
            setLoader(true);
            const result = await get_material_request({ id });
            if (result?.status) {
                handleData(result?.data);
            } else {
                toast?.error(result?.message);
            }
        } else {
            values[0].options[0].form.value = new Date();
            setValues([...values]);
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Form
                form={values}
                setForm={setValues}
                formdata={formdata}
                buttonLoader={buttonLoader}
            >
                <Bodycomponent>
                    <Titlecomponent index={1} title={"Items"} />
                    <Formdata>
                        <Headercomponent index={0} name={"Details"} required={true} />
                        <MRTable
                            details={details}
                            setDetails={setDetails}
                            ref={focus}
                        />
                    </Formdata>
                </Bodycomponent>
            </Form>
        </Header>
    );
};

export default MaterialRequestForm;